import template from "./two-factor.html";
import {TwoFactorController} from "./two-factor.controller";
import "./two-factor.scss";

const TwoFactorComponent = {
    template,
    controller: TwoFactorController,
    controllerAs: "twoFactor"
};

export default TwoFactorComponent; 


// WEBPACK FOOTER //
// ./sources/components/auth/two-factor/two-factor.component.js